var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
export var SidebarItem = function (props) {
    var _a;
    return (_jsx(Link, __assign({ to: props.path }, { children: _jsxs("div", __assign({ className: twMerge('flex cursor-pointer flex-row items-center gap-[16px] bg-transparent py-[14px] pl-[24px] text-sm font-normal leading-5 tracking-tight text-[#383838]', props.currentPath === props.path ||
                (props.isMutltiPathItem && ((_a = props.currentPath) === null || _a === void 0 ? void 0 : _a.includes(props.path)))
                ? 'border-r-[2px] border-solid border-primary bg-[#EDF2FA] text-primary'
                : 'border-none') }, { children: [props.icon && (_jsx(props.icon, { size: '20px', fill: props.currentPath === props.path ? '#2175F3' : 'black' })), props.label] })) })));
};
